import React from 'react';
import { injectIntl } from 'react-intl';
import Button from '@UI/Button';

function ClearButton({ clearField, intl }) {
  return (
    <Button
      className="button--icon-only"
      data-rs-clearable-button
      aria-hidden={false}
      tabIndex="-1"
      onClick={clearField}
      aria-label={intl.formatMessage({ id: 'Close' })}
    >
      <span>
        {intl.formatMessage({ id: 'Form.SearchFieldClearText' })}
      </span>
      { /* allows mouse interaction */
        /* eslint-disable-next-line */ }
      <span className="icon fill-brand--blue" role="button" onClick={clearField}>
        <svg>
          <use
            xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#close"
          />
        </svg>
      </span>
    </Button>
  );
}

export default injectIntl(ClearButton);
